import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import styles from './index.module.scss';
const TipsA = () => {
    const { t } = useLang('theProduct.BannerA');
    return <div className="banner-tips-a">{t('tips1')}</div>;
};
export default function Comp() {
    const { t } = useLang('theProduct.BannerA');
    const dataA: EcoBannerProps = {
        layout: 'top-center',

        pc: 'https://websiteoss.ecoflow.com/upload/image/1735808667056/gray-bg.jpg',
        label: t('label'),
        labelColor: '#D11504',
        title: t('title'),
        desc: t('desc'),

        childrenB: <TipsA />,
    };
    return (
        <div className={styles.comp}>
            <EcoBanner {...dataA} />
        </div>
    );
}
